import React from "react";
import Header from "../Header/Header";
import { SyndigoUpload } from "./SyndigoUpload";

export const SyndigoUploadWrapper = () => {
    return (
        <div className="syndigo-upload-page">
            <div className="syndigo-upload-brand">
                <Header />
            </div>
            <SyndigoUpload uploadURL="api/syndigo/upload-asset"/>
        </div>
    )
}